import moment from 'moment';
import numeral from 'numeral';
import { toDecimal4 } from 'src/utils/toDecimal';

function getValue(columnSettings, props) {
  if (columnSettings?.renderValue)
    return numeral(toDecimal4(columnSettings?.renderValue(props))).format(
      columnSettings?.format ?? '0,0.00'
    );

  if (columnSettings?.mapValue)
    return columnSettings?.mapValue?.[props?.[columnSettings?.fld] ?? ''] ?? '';

  if (columnSettings?.isCurrency)
    return numeral(toDecimal4(props?.[columnSettings?.fld] ?? 0)).format(
      columnSettings?.format ?? '0,0.00'
    );

  if (columnSettings?.isDate)
    return moment(props?.[columnSettings?.fld] ?? '').format(
      columnSettings?.format ?? 'YYYY-MM-DD'
    );

  return props?.[columnSettings?.fld] ?? '';
}

export default getValue;
